export default __webpack_public_path__ + "static/media/json.0286d933.svg";